class DashboardComedorService {
  constructor() {}
  resources = () => ({
    dashboard: {
      uri: `/v1/unidadcomedor/dashboard`,
      method: ['get']
    },
    planillas: {
      uri: `/v1/planillas`,
      method: ['get']
    },
    sector: {
      uri: `/v1/sectorespadres`,
      method: ['get']
    },
    comedor: {
      uri: `/v1/unidadcomedor/comedorxvotacion`,
      method: ['get']
    }
  });
}

export default DashboardComedorService;
